/**
 * platform-lab zod 스키마 — react-hook-form resolver 용
 */
import { z } from 'zod';

export const idGenSchema = z.object({
  kind: z.enum(['UUID', 'UUID_V7', 'ULID', 'SHORT', 'SNOWFLAKE', 'ALL']),
  length: z.coerce.number().int().min(4).max(64).optional(),
});

export type IdGenFormValues = z.infer<typeof idGenSchema>;

export const idBatchSchema = z.object({
  kind: z.enum(['UUID', 'UUID_V7', 'ULID', 'SHORT', 'SNOWFLAKE', 'ALL']),
  count: z.coerce.number().int().min(1).max(1000),
});

export type IdBatchFormValues = z.infer<typeof idBatchSchema>;

export const asyncSubmitSchema = z.object({
  delayMs: z.coerce.number().int().min(0).max(5000),
  label: z.string().max(100).optional(),
});

export type AsyncSubmitFormValues = z.infer<typeof asyncSubmitSchema>;

export const resilienceCbSchema = z.object({
  failureRate: z.coerce.number().int().min(0).max(100),
});

export type ResilienceCbFormValues = z.infer<typeof resilienceCbSchema>;

export const resilienceRetrySchema = z.object({
  failTimes: z.coerce.number().int().min(0).max(10),
});

export type ResilienceRetryFormValues = z.infer<typeof resilienceRetrySchema>;

export const resilienceTimeoutSchema = z.object({
  delayMs: z.coerce.number().int().min(0).max(10000),
});

export type ResilienceTimeoutFormValues = z.infer<typeof resilienceTimeoutSchema>;

export const versioningSchema = z.object({
  msg: z.string().min(1).max(200),
});

export type VersioningFormValues = z.infer<typeof versioningSchema>;

export const sessionAttributeSchema = z.object({
  key: z.string().min(1).max(100),
  value: z.string().min(1).max(1000),
});

export type SessionAttributeFormValues = z.infer<typeof sessionAttributeSchema>;
